import api from '../lib/api';

const favoriteService = {
    toggleFavoriteAuction: async (auctionId) => {
        const response = await api.post(`/auctions/${auctionId}/favorite`);
        return response;
    },

    toggleFavoriteLot: async (lotId) => {
        const response = await api.post(`/lots/${lotId}/favorite`);
        return response;
    },

    getFavoriteAuctions: async (params = {}) => {
        const response = await api.get('/favorite-auctions', { params });
        return response.data;
    },

    getFavoriteLots: async (params = {}) => {
        const response = await api.get('/favorite-lots', { params });
        return response.data;
    }
};

export default favoriteService; 